import RoleAuthorization from '@/components/Role/RoleAuthorization'

let RoleRouter = [{
  path: '/role/authorization',
  name: 'RoleAuthorization',
  component: RoleAuthorization,
  meta: {
    title: 'Autorisations des rôles',
    requiresAuth: true,
    authorizations: ['role-rights_edit', 'desktop_access']
  }
}]

export default RoleRouter



// WEBPACK FOOTER //
// ./src/components/Role/router.js